import angular from 'angular';
import directive from './threat-score.directive';


export default angular.module('app.components.advisory.bcp.settings.threatScore', [])
  .directive('bcpThreatScore', directive)
  .name;

console.log('app.components.advisory.bcp.settings.threatScore created');
